var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9784 7.22874L10.9786 7.22855C11.0723 7.13479 11.125 7.00761 11.125 6.875C11.125 6.74239 11.0723 6.61521 10.9786 6.52145C10.8848 6.42768 10.7576 6.375 10.625 6.375C10.4924 6.375 10.3652 6.42768 10.2714 6.52145L10.2713 6.52163L8 8.79289L5.72861 6.52151C5.63479 6.42768 5.50761 6.375 5.375 6.375C5.24239 6.375 5.11521 6.42768 5.02145 6.52145C4.92768 6.61521 4.875 6.74239 4.875 6.875C4.875 7.00761 4.92768 7.13479 5.02145 7.22855L7.64645 9.85355C7.74021 9.94732 7.86739 10 8 10C8.13261 10 8.25978 9.94732 8.35355 9.85355L10.9784 7.22874Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5V9.5C7.5 9.77614 7.72386 10 8 10C8.27614 10 8.5 9.77614 8.5 9.5V2.5C8.5 2.22386 8.27614 2 8 2C7.72386 2 7.5 2.22386 7.5 2.5Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13V9.5C3 9.22386 2.77614 9 2.5 9C2.22386 9 2 9.22386 2 9.5V13C2 13.4142 2.29289 13.7071 2.29289 13.7071C2.58579 14 3 14 3 14H13C13.4142 14 13.7071 13.7071 13.7071 13.7071C14 13.4142 14 13 14 13V9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5V13H3Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.0941ef5f8911e6a194ba214e645ce704.svg";
export { ForwardRef as ReactComponent };